var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_664_4574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C7.97147 0 0 7.97141 0 18C0 28.0286 7.97147 36 18 36C28.0285 36 36 28.0286 36 18C36 7.97141 28.0285 0 18 0ZM18 33.4284C9.5143 33.4284 2.57142 26.4858 2.57142 18C2.57142 9.51416 9.5143 2.57162 18 2.57162C26.4857 2.57162 33.4286 9.51416 33.4286 18C33.4286 26.4858 26.4857 33.4284 18 33.4284ZM15.4286 25.2002L9 18.7715L11.0571 16.7143L15.4286 21.0858L24.9429 11.5716L27 13.6288L15.4286 25.2002Z",
    fill: "#368A04"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_664_4574)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_664_4574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: -3,
    width: 42,
    height: 42
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.57129 38.5707H38.5716V-2.57227H-2.57129V38.5707Z",
    fill: "#368A04"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_664_4574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12.8564 -12.8574H48.8579V48.8566H-12.8564V-12.8574Z",
    fill: "#203662"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.cd6700bb6f209a7b190c933cbe7161c8.svg";
export { ForwardRef as ReactComponent };